<style lang="scss">
@import "../../../sass/variables";


#segment-action-modal {

  .modal-content {
    border-radius: 16px !important;

    .modal-header {
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
    }

    .modal-body {
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
    }
  }


  .fa-chevron-down {
    position: absolute;
    font-size: 10px;
    right: 20px;
    bottom: 20px;
    z-index: 51;
  }

  .form-control {
    background: $salesflow-bg-content;
    border-radius: 8px;
    height: 50px;
    border: 0;
    outline: 1px solid $salesflow-outline-gray-medium;
    font-size: 1rem !important;
  }

  .multiselect {
    border: 0;
    background: $salesflow-bg-content;
    border-radius: 8px;
    height: 50px;
    outline: 1px solid $salesflow-outline-gray-medium;
    z-index: 50 !important;

    input,
    select {
      padding: 12px 18px;

      &::placeholder {
        color: $salesflow-outline-gray-medium !important;
        font-weight: 500;
        font-size: 1rem !important;
      }
    }

    input.multiselect__input {
      border: 0;
      border-radius: inherit;
      outline: none;
    }

    .multiselect__single {
      border-radius: inherit;
      height: inherit;
      background-color: $salesflow-bg-content;
      ;
    }

    .multiselect__tags {
      padding: 0;
      display: flex;
      align-self: center;
      padding: 12px 14px;
      outline: 1px solid $salesflow-outline-gray-medium;
      background-color: $salesflow-bg-content;
      border-radius: inherit;
      height: inherit;

      span.multiselect__placeholder {
        border-radius: inherit;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: $salesflow-outline-gray-medium;
        font-weight: 500;
        font-size: 1rem !important;
        line-height: 150%;
        background-color: $white;
      }
    }
  }
}
</style>

<template>
  <BModal id="segment-action-modal" ref="segment-action-modal" hide-footer="hide-footer" modal-class="modal-width-420">
    <template slot="modal-header">
      <h4 v-if="!action.name">
        <i class="fa fa-circle-o-notch fa-spin" /> {{ __("Carregando") }}
      </h4>
      <h4 class="modal-title" v-else>
        {{ action.name }} <!--  <br /><small class="ml-1">{{ __("Segmentação") }}: {{ segment.name }}</small> -->
      </h4>
      <button class="close" type="button" aria-label="Close" @click="closeModal()">
        <span aria-hidden="true">×</span>
      </button>
    </template>
    <template slot="default">
      <form method="post" v-if="action.name">
        <div class="form-group" v-if="actionHasOptions()">
          <div class="position-relative">
            <label>{{ __("Selecione") }}</label>
            <i class="fa fa-solid fa-chevron-down" />
            <Multiselect :show-labels="false" :group-values="multiSelect.groupValue" v-model="action.value"
              :options="action.options" :multiple="false" group-label="name" :group-select="false"
              :placeholder="multiSelectPlaceholder" track-by="name" label="name"
              :deselectgrouplabel="multiSelect.deselectGroupLabel" :deselectlabel="multiSelect.deselectLabel"
              :selectgrouplabel="multiSelect.multiSelect" :selectlabel="multiSelect.selectLabel"
              :selectedlabel="multiSelect.selectedLabel" />
          </div>
        </div>
        <div class="form-group" v-if="!actionHasOptions()">
          <input class="form-control border" type="text" name="action.options" v-model="action.value"
            v-if="!action.textarea" :placeholder="action.options.placeholder" />
          <textarea class="form-control" name="action.options" v-model="action.value"
            :placeholder="action.options.placeholder" maxlength="159" v-else />
        </div>
        <div class="modal-footer default-modal-footer" v-if="action.name">
          <button class="salesflow-btn salesflow-btn-secondary mt-4" type="submit" @click.prevent="applySelectedAction()"
            :disabled="loading">
            <span v-if="!loading">{{ __("Aplicar") }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin" /></span>
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal } from "bootstrap-vue";
import { Confirm } from "../../services/Confirm";

export default {
  components: {
    BModal,
  },

  created() {
    Bus.$on("SegmentActionSelected", ([action, segment]) => {
      this.action = action;
      this.action.options = {};
      this.segment = segment;

      this.loadActionTypeValues();

      if (this.showActionOptions()) {
        this.$refs["segment-action-modal"].show();
      } else {
        this.applySelectedAction(true);
      }
    });
  },

  data() {
    return {
      loading: true,
      action: {},
      segment: {},
      multiSelect: {
        multiple: false,
        placeholder: this.__("Selecione"),
        noResult: this.__("Nenhuma opção encontrada"),
        groupValue: "",
        deselectGroupLabel: this.__("Deselecionar todos"),
        deselectLabel: this.__("Deselecionar item"),
        selectGroupLabel: this.__("Selecionar todos"),
        selectLabel: this.__("Selecionar item"),
        selectedLabel: this.__("Selecionado"),
      },
    };
  },

  computed: {
    multiSelectPlaceholder() {
      if (this.action.type && this.action.type.placeholder) {
        return this.action.type.placeholder;
      }

      if (this.action.placeholder) {
        return this.action.placeholder;
      }

      return "Selecione";
    },
  },

  methods: {
    actionHasOptions() {
      return this.action.options instanceof Array && this.action.options.length > 0;
    },

    showActionOptions() {
      if (this.actionHasOptions && this.action.placeholder) {
        return true;
      }

      if (this.action.options && this.action.options.placeholder) {
        return true;
      }

      return false;
    },

    loadActionTypeValues() {
      this.loading = true;

      this.$http
        .get("/automation/action/value", { params: { type: this.action.type } })
        .then(({ data }) => {
          this.action.options = data;

          this.multiSelect.groupValue = "";

          if (this.actionHasOptions) {
            const filtered = this.action.options.filter(
              (option) => option.groupOptions.length > 0
            );

            if (filtered.length > 0) {
              this.multiSelect.groupValue = "groupOptions";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async applySelectedAction(directAction = false) {
      if (
        !(await Confirm(
          `${this.__("Aplicar")} ${this.action.name} ${this.__(
            "em todos os leads desta segmentação?"
          )}`
        ))
      ) {
        return;
      }

      this.loading = true;

      if (directAction) {
        Bus.$emit("loading", true);
      }

      if (typeof this.action.value == "object" && this.action.value !== null) {
        this.action.value = this.action.value.value;
      }

      this.$http
        .post(`/lead/segment/${this.segment.id}/action`, { action: this.action })
        .then(function (response) {
          Alert.success(this.__("Ação iniciada."));
        })
        .catch(function () {
          Alert.error(
            this.__(
              "Houve um erro ao tentar aplicar essa ação. Tente novamente mais tarde."
            )
          );
        })
        .finally(function () {
          Bus.$emit("loading", false);

          this.closeModal();
        });
    },

    closeModal() {
      this.action.value = "";

      this.$refs["segment-action-modal"].hide();
    },
  },
};
</script>
